import { ToastContainer } from "react-toastify";
import QuestionnaireWizard from "./QuestionnaireWizard";
import "react-toastify/dist/ReactToastify.css";
import "../components/toast/ClassicyToast.scss";

export default function SubmitStoryWindow() {
  return (
    <>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={true}
        newestOnTop={true}
        closeOnClick={false}
        rtl={false}
        pauseOnFocusLoss={false}
        draggable={false}
        pauseOnHover={false}
        closeButton={false}
        icon={false}
      />
      <QuestionnaireWizard />
    </>
  );
}
